module.exports = __webpack_public_path__ + "0-es2015.99da4fe789fe0eec6594.worker.js"